<div *ngIf="!cargandoInterfaces">
  <ngb-alert *ngIf="mensajeError" class="alert alert-danger"> 
    {{mensajeError}}
  </ngb-alert>
  <div id="divisor" *ngFor="let interface of interfaces; let i=index">
    <button type="button" [class.button]="true" [ngStyle]="pintarInterfaz(i)" class="my-2 shadow list-group-item list-group-item-action" style="border-radius: 2em;"
      (click)="mostrarDetalle(i)">
      <div class="w-100 text-center">
        <p class="my-1">{{ interface?.nombre }} </p>
      </div>
    </button>
  </div>
</div>